import { render, staticRenderFns } from "./OutsideHouse.vue?vue&type=template&id=a3412106&scoped=true"
import script from "./OutsideHouse.vue?vue&type=script&lang=ts"
export * from "./OutsideHouse.vue?vue&type=script&lang=ts"
import style0 from "./OutsideHouse.vue?vue&type=style&index=0&id=a3412106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3412106",
  null
  
)

export default component.exports